import type {CompanyDetail} from '@openapi/prtimes';
import {companyApi} from '../client';

export const getCompany = async (
  {companyId}: {companyId: number},
  initOverrides?: RequestInit,
): Promise<CompanyDetail> =>
  companyApi.getCompanyById(
    {
      companyId,
    },
    initOverrides,
  );
